export default "__VITE_ASSET__CxwPDErk__"